import React from 'react';

export default class Page3 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt task">
                                    <div className="innerpadding">


                                        <div className="ilead-contentarea">
                                            <div className="circle_title-first"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>A MODEL OF OPTIMISM
                                            </div>
                                            <p>This model is of a solution-focused thinking approach which
                                                reduces a task or problem to smaller
                                                parts and focuses on the success of resolving each in turn. It’s
                                                an approach which helps maintain
                                                positivity and motivation. It demonstrates that understanding
                                                how success looks and feels
                                                enables us to recognise our achievements and praise ourselves
                                                and others for them. This, in turn,
                                                augments teamwork and the drive for success, which makes
                                                positive change more likely.</p>
                                            <div className="innovativeimg">

                                                <img
                                                    src={require('@images/optimise_img.png')}
                                                    alt=""/>

                                            </div>

                                            <div className="circle_title"><img
                                                src={require('@images/Browndot.png')}
                                                alt=""/>HOW OPTIMISTIC ARE YOU?
                                            </div>
                                            <p>When you feel negative or pessimistic about a situation, use the
                                                following questions to start
                                                thinking more positively. It is useful to record the answers to
                                                your questions so that you have a
                                                contract with yourself, clearly demonstrating your positive
                                                outlook.</p>
                                            <p>What is your belief? Below is an example to illustrate the
                                                Optimism Exercise:</p>

                                            <div className="border_subtitle">Belief: I am terrible at
                                                presentations
                                            </div>

                                            <ol className="brownbullet-list listcontentSpacing">
                                                <li><p><span className="subtiltereg">What evidence do I have that my negative beliefs are correct?</span><br/>I
                                                    just gave a presentation, my computer failed, I froze and
                                                    forgot what I was saying. I looked
                                                    like an idiot in front of my boss.</p></li>
                                                <li><p><span className="subtiltereg">What evidence do I have that my negative beliefs are NOT correct?</span><br/>I
                                                    have given other presentations before that have gone well.
                                                </p></li>
                                                <li><p><span className="subtiltereg"> What alternative explanations are there for what happened?</span>
                                                </p></li>

                                            </ol>
                                            <br/>
                                            <table
                                                className="ilead_v_sport tablesrink ilead_v_sport_new_task"
                                                border="0" cellPadding="0" cellSpacing="0" width="100%">
                                                <tbody>
                                                <tr>
                                                    <th className="green_curve " align="left" valign="top"
                                                        width="50%">Things which are changeable
                                                    </th>
                                                    <th className=" green_curve1" align="left" valign="top"
                                                        width="50%">Things which were out of my control
                                                    </th>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen uiheading" align="left"
                                                        valign="center" width="50%"><p>I was tired as I was
                                                        up late, preparing.</p>
                                                    </td>
                                                    <td className="lightgreen uiheading" align="left"
                                                        valign="center" width="50%">
                                                        <div className=""><p>My colleague didn’t give me the
                                                            information I was
                                                            presenting on until the night before.</p></div>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className="darkgreen uiheading" align="left"
                                                        valign="center" width="50%"><p>I haven’t been to the
                                                        IT desk to update my
                                                        laptop recently.</p>
                                                    </td>
                                                    <td className="darkgreen uiheading" align="left"
                                                        valign="center" width="50%"><p>The computer froze
                                                        mid-presentation because it
                                                        decided to update itself.</p>
                                                    </td>

                                                </tr>
                                                <tr>
                                                    <td className="lightgreen uiheading" align="left"
                                                        valign="center" width="50%"><p>It wasn’t on a topic
                                                        I am familiar with.</p>
                                                    </td>
                                                    <td className="lightgreen  uiheading" align="left"
                                                        valign="center" width="50%"><p>I was a stand-in for
                                                        the team’s expert on the topic.</p>
                                                    </td>

                                                </tr>
                                                </tbody>
                                            </table>

                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page2')}
                                                    className="button-next-previous-done task">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page4')}
                                                    className="button-next-previous-done task">Next &gt;&gt;</div>
                                            </div>
                                        </div>

                                    </div>


                                </div>


                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
        ;
    }
}